import gsap from "gsap";
import { getHeroSwiper } from './setHeroSlider';

const setAdmissionsTopInitAnim = () => {

  const swiper = getHeroSwiper();

  const hero = document.querySelector('.page-admissions-top .section-hero');
  if (!hero) return false;

  const img = hero.querySelector('.hero-slider'),
    title = hero.querySelector('.hero-headline'),
    header = document.querySelector('#site-admissions-header');

  const heroAnim = gsap.timeline();

  // gsap.set(title, {
  //   yPercent: -50,
  // })

  const kvAnim = gsap.timeline()
    .to(title, {
      opacity: 1,
      duration: 1,
      ease: 'sine.inOut',
    })
    .to(img, {
      opacity: 1,
      duration: 1,
      ease: 'sine.inOut',
    })
    .add(() => {
      if (swiper) swiper.autoplay.start();
    },'+=0')
    .from(title, {
      bottom: '50%',
      yPercent: 50,
      duration: 1,
      ease: 'power3.inOut',
      clearProps: "bottom,transform"
    }, '-=.6')

  const headerAnim = gsap.timeline()
    .to(header, {
      opacity: 1,
      duration: .8,
      ease: 'power3.out',
    })
    .from(header, {
      yPercent: -50,
      duration: .8,
      ease: 'power3.out',
      clearProps: "transform"
    }, '<')

  heroAnim.add(kvAnim);
  heroAnim.add(headerAnim, '-=.5');
}

export default setAdmissionsTopInitAnim;